import styles from './index.module.css';
import ImageOne from '../../assets/images/landingPage/ardilla_mockup.png';
import RocketImg from '../../assets/images/landingPage/rocket_img.png';
import HeroImg from '../../assets/images/landingPage/about-ardilla_img.png';
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useRef } from 'react';

export const HeroSection = () => {

    gsap.registerPlugin(ScrollTrigger, useGSAP);
    const sectionRef = useRef(null);
    const imageRef = useRef(null);

    useGSAP(() => {
        if (!sectionRef.current || !imageRef.current) return;

        gsap.to(imageRef.current, {
            y: -2000,          // fly much higher (like rocket)
            scale: 0.6,        // shrink as it goes up
            opacity: 0,        // fade out completely
            zIndex: -10,        // push behind after takeoff
            ease: "power2.in", // strong acceleration upwards
            scrollTrigger: {
                trigger: sectionRef.current,
                start: "top top",     // start as soon as section enters
                end: "bottom top",    // finish when section leaves
                scrub: true,          // link to scroll
            },
        });
    }, []);

    return (
        <div ref={sectionRef} className={styles.headerSec}>
            <div className={styles.topSec}>
                <div className={styles.label}><p className={styles.headerText}>Results-Driven Software Development Company</p></div>
                <p className={styles.headerTitle}>Your Trusted Partner for <br /> Web, Mobile, AI, and Digital Systems</p>
                <p className={styles.tagText}><span>Web Development</span> <span className={styles.divideIcon}>||</span> <span>Software Solutions</span><span className={styles.divideIcon}>||</span> <span>Mobile Apps</span><span className={styles.divideIcon}>||</span> <span>Artificial Intelligence</span></p>
                <p className={styles.tagSentence}>At Ardillalabs, we believe great ideas deserve great execution. That’s why we design and develop software solutions that not only look beautiful, but also help your business grow faster, smarter, and stronger.Whether you need a business website, a scalable system, or a mobile app, our team delivers innovation that empowers your future.</p>
                <button className={styles.loginBtn} onClick={() => {
                    const section = document.getElementById('contact');
                    if (section) {
                        section.scrollIntoView({ behavior: "smooth" });
                    }
                }}>Get Started</button>
                <div className={styles.cardGrid}>
                </div>
            </div>
            <div className={styles.bottomSec}>
                <div className={styles.imageBack}>
                    <div className={styles.imageContainer}>
                        {/* <img src={ImageOne} alt='Web' className={styles.imageBase} />
                        <img ref={imageRef} src={RocketImg} alt='Web' className={styles.imageTwo} /> */}
                        <img src={HeroImg} alt='Person' className={styles.HeroImg} />
                    </div>
                    {/* <img src={ImageOne} alt='Person' className={styles.imageOne} />
                    <img src={ImageOne} alt='Person' className={styles.imageOne} />
                    <img src={ImageOne} alt='Person' className={styles.imageOne} /> */}
                </div>
            </div>
        </div>
    )
}

const LandingPage = () => {
    return (
        <>
            <div className={styles.landingPageMain}>
                <div className={styles.landingPageContainer}>
                    <HeroSection />
                </div>
            </div>
        </>
    );
}

export default LandingPage;